import React from "react"
import { FlexProps, Flex, Switch, FormLabel } from "@chakra-ui/core"
import Body from "../../components/typography/Body"

type InStockFilterProps = FlexProps & {
  id: string
  enabled: boolean
  setEnabled: (enabled: boolean) => void
}

export default function InStockFilter({
  id,
  enabled,
  setEnabled,
  ...props
}: InStockFilterProps) {
  return (
    <Flex justify="center" align="center" ml="1rem" {...props}>
      <Switch
        id={id}
        h="1.25rem"
        color="primarySet"
        isChecked={!!enabled}
        onChange={() => setEnabled(!enabled)}
        mr="0.5rem"
      />
      <FormLabel htmlFor={id} h="1.25rem" cursor="pointer">
        <Body color={enabled ? "dusk" : "dawn"} fontWeight="100">
          In Stock
        </Body>
      </FormLabel>
    </Flex>
  )
}
